import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { constants } from "@lib/constants";

// Initial state
const initialState = {
  allCompetitions: [],
  allCompetitionsLoading: false,
  competitionDetails: null,
  competitionLoading: false,
  error: null,
};

// 🔹 Fetch all competitions
export const fetchCompetitions = createAsyncThunk(
  "competitionReducer/fetchCompetitions",
  async ({ axiosGet,params=false }, thunkAPI) => {
    try {
      const response = await axiosGet(`${constants.LIST_COMPETITIONS}`);
      return response.data.records;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// 🔹 Fetch single competition by ID
export const fetchCompetitionDetails = createAsyncThunk(
  "competitionReducer/fetchCompetitionDetails",
  async ({ axiosGet, id }, thunkAPI) => {
    try {
      const response = await axiosGet(`competition/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Slice
const competitionReducer = createSlice({
  name: "competitionReducer",
  initialState,
  reducers: {
    clearCompetitionDetails: (state) => {
      state.competitionDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Fetch all competitions
      .addCase(fetchCompetitions.pending, (state) => {
        state.allCompetitionsLoading = true;
        state.error = null;
      })
      .addCase(fetchCompetitions.fulfilled, (state, action) => {
        console.log("COMPETITIONS API FULFILLED");
        state.allCompetitions = action.payload;
        state.allCompetitionsLoading = false;
      })
      .addCase(fetchCompetitions.rejected, (state, action) => {
        state.allCompetitionsLoading = false;
        state.error = action.payload;
      })

      // 🔹 Fetch single competition
      .addCase(fetchCompetitionDetails.pending, (state) => {
        state.competitionLoading = true;
        state.error = null;
      })
      .addCase(fetchCompetitionDetails.fulfilled, (state, action) => {
        state.competitionDetails = action.payload;
        state.competitionLoading = false;
      })
      .addCase(fetchCompetitionDetails.rejected, (state, action) => {
        state.competitionLoading = false;
        state.error = action.payload;
      });
  },
});

// Exports
export const { clearCompetitionDetails } = competitionReducer.actions;
export default competitionReducer.reducer;
